module.exports = __webpack_public_path__ + "static/media/plazo-forzoso.822ad303.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/plazo-forzoso.svg
// module id = 162
// module chunks = 0